
import * as date from './date.js'


import tool from './tool.js'

export default {
    date,
    ...tool
};

